import { makeStyles } from "@material-ui/core"

function makeComponentStyles(styles){
  return makeStyles(theme => styles(theme))();
}

export { makeComponentStyles };
